
import "./App.css";

function App() {
  return (
    <div className="portfolio">
      <nav className="navbar">
        <div className="logo">RN.</div>
        <div className="nav-links">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#skills">Skills</a>
          <a href="#projects">Projects</a>
          <a href="#experience">Experience</a>
          <a href="#contact">Contact</a>
        </div>
      </nav>

      <main>
        <section className="hero" id="home">
          <div className="hero-content">
            <div className="availability">
              <span className="status-dot"></span>
              Available for freelance opportunities
            </div>
            <p className="eyebrow">FULL-STACK WEB DEVELOPER</p>
            <h1>
              I build
              <span> digital products</span>
              that work.
            </h1>
            <p className="hero-text">
              Hi, I’m Rabail Noureen — a Computer Science student and
              Full-Stack Web Developer focused on building modern,
              responsive and reliable web applications.
            </p>
            <div className="tech-stack">
              <span>React.js</span>
              <span>Next.js</span>
              <span>Node.js</span>
              <span>MongoDB</span>
            </div>
            <div className="hero-buttons">
              <a href="#projects" className="primary-btn">
                Explore My Work <span>↗</span>
              </a>
              <a href="#contact" className="secondary-btn">
                Let’s Connect
              </a>
            </div>
            <div className="quick-info">
              <div>
                <strong>Frontend</strong>
                <span>React · Next.js</span>
              </div>
              <div>
                <strong>Backend</strong>
                <span>Node · Express</span>
              </div>
              <div>
                <strong>Database</strong>
                <span>MongoDB</span>
              </div>
            </div>
          </div>

          <div className="hero-card">
            <div className="floating-badge badge-one">
              <span>✦</span>
              Clean Code
            </div>
            <div className="floating-badge badge-two">
              <span>✓</span>
              Responsive
            </div>
            <div className="code-window">
              <div className="window-top">
                <div className="window-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div className="window-title">rabail-developer.js</div>
              </div>
              <div className="code-content">
                <p>
                  <span className="purple">const</span>{" "}
                  <span className="blue">developer</span> = {"{"}
                </p>
                <p className="indent">
                  name: <span className="green">"Rabail Noureen"</span>,
                </p>
                <p className="indent">
                  role:{" "}
                  <span className="green">"Full-Stack Developer"</span>,
                </p>
                <p className="indent">
                  frontend:{" "}
                  <span className="green">["React", "Next.js"]</span>,
                </p>
                <p className="indent">
                  backend:{" "}
                  <span className="green">["Node.js", "Express"]</span>,
                </p>
                <p className="indent">
                  database: <span className="green">"MongoDB"</span>,
                </p>
                <p className="indent">
                  available: <span className="orange">true</span>
                </p>
                <p>{"};"}</p>
                <p className="code-comment">
                  {"// turning ideas into real products"}
                </p>
                <p className="cursor">▊</p>
              </div>
            </div>
            <div className="hero-glow"></div>
          </div>
        </section>

        <section className="about section" id="about">
          <div className="section-label">01 — ABOUT ME</div>
          <div className="section-content">
            <h2>Turning ideas into functional digital experiences.</h2>
            <p>
              I’m a Computer Science student and Full-Stack Web Developer
              passionate about creating clean, responsive and practical
              digital solutions.
            </p>
            <p>
              My development experience includes frontend applications,
              REST APIs, authentication, databases and responsive
              interfaces. I enjoy transforming requirements into polished
              products that are simple to use and reliable in practice.
            </p>
          </div>
        </section>

        <section className="skills section" id="skills">
          <div className="section-label">02 — SKILLS</div>
          <div className="skills-grid">
            <div className="skill-card">
              <span>01</span>
              <h3>Frontend</h3>
              <p>React.js · Next.js · JavaScript · HTML5 · CSS3</p>
            </div>
            <div className="skill-card">
              <span>02</span>
              <h3>Backend</h3>
              <p>Node.js · Express.js · REST APIs · Authentication</p>
            </div>
            <div className="skill-card">
              <span>03</span>
              <h3>Database</h3>
              <p>MongoDB · Mongoose · Data Modeling · CRUD</p>
            </div>
            <div className="skill-card">
              <span>04</span>
              <h3>Tools</h3>
              <p>Git · GitHub · Postman · VS Code</p>
            </div>
          </div>
        </section>

        <section className="projects section" id="projects">
          <div className="section-label">03 — SELECTED WORK</div>
          <div className="projects-heading">
            <div>
              <p className="eyebrow">MY PROJECTS</p>
              <h2>Things I’ve built.</h2>
            </div>
            <p className="projects-intro">
              A selection of practical projects demonstrating frontend
              development, backend engineering, API design and modern
              web development workflows.
            </p>
          </div>

          <div className="project-list">
            <article className="project-card featured-project">
              <div className="project-visual expense-visual">
                <div className="visual-top">
                  <span>ExpenseFlow</span>
                  <span>Dashboard</span>
                </div>
                <div className="mini-dashboard">
                  <div className="mini-card">
                    <span>Total Balance</span>
                    <strong>Rs. 48,500</strong>
                  </div>
                  <div className="mini-card">
                    <span>Income</span>
                    <strong>Rs. 75,000</strong>
                  </div>
                  <div className="mini-card">
                    <span>Expenses</span>
                    <strong>Rs. 26,500</strong>
                  </div>
                </div>
                <div className="mini-chart">
                  <span></span><span></span><span></span><span></span>
                  <span></span><span></span><span></span>
                </div>
              </div>
              <div className="project-content">
                <div className="project-meta">
                  <span>01</span>
                  <span>WEB APPLICATION</span>
                </div>
                <h3>ExpenseFlow</h3>
                <p>
                  A personal finance dashboard for managing income,
                  expenses, budgets, recurring transactions and financial
                  analytics through a responsive interface.
                </p>
                <div className="project-features">
                  <span>✓ Responsive Dashboard</span>
                  <span>✓ Expense Management</span>
                  <span>✓ Analytics &amp; Charts</span>
                  <span>✓ Dark Mode</span>
                </div>
                <div className="tags">
                  <span>React.js</span>
                  <span>Recharts</span>
                  <span>LocalStorage</span>
                  <span>CSS</span>
                </div>
                <div className="project-actions">
                  <a
                    href="https://github.com/rNoureen64/Syntecxhub_ExpenseFlow"
                    target="_blank"
                    rel="noreferrer"
                    className="project-btn primary-project-btn"
                  >
                    View GitHub <span>↗</span>
                  </a>
                  <a
                    href="#expenseflow-details"
                    className="project-btn secondary-project-btn"
                  >
                    Project Details
                  </a>
                </div>
              </div>
            </article>

            <article className="project-card featured-project">
              <div className="project-visual api-visual">
                <div className="api-header">
                  <span className="api-method">GET</span>
                  <span>/api/products</span>
                </div>
                <div className="api-response">
                  <div>
                    <span className="json-key">"products"</span>
                    <span>: [</span>
                  </div>
                  <div className="json-indent"><span>{"{"}</span></div>
                  <div className="json-indent-more">
                    <span className="json-key">"name"</span>
                    <span>:</span>
                    <span className="json-value">"Smart Fitness Band"</span>
                  </div>
                  <div className="json-indent-more">
                    <span className="json-key">"price"</span>
                    <span>:</span>
                    <span className="json-number">6999</span>
                  </div>
                  <div className="json-indent-more">
                    <span className="json-key">"stock"</span>
                    <span>:</span>
                    <span className="json-number">35</span>
                  </div>
                  <div className="json-indent"><span>{"}"}</span></div>
                  <div><span>]</span></div>
                </div>
                <div className="api-status">
                  <span>●</span>
                  API Online
                </div>
              </div>
              <div className="project-content">
                <div className="project-meta">
                  <span>02</span>
                  <span>BACKEND API</span>
                </div>
                <h3>Product Catalog API</h3>
                <p>
                  A REST API for product catalog management with
                  authentication, CRUD operations, search, filtering,
                  pagination, validation and analytics.
                </p>
                <div className="project-features">
                  <span>✓ JWT Authentication</span>
                  <span>✓ Search &amp; Filtering</span>
                  <span>✓ Pagination &amp; Analytics</span>
                  <span>✓ Secured Endpoints</span>
                </div>
                <div className="tags">
                  <span>Node.js</span>
                  <span>Express.js</span>
                  <span>MongoDB</span>
                  <span>Mongoose</span>
                  <span>JWT</span>
                </div>
                <div className="project-actions">
                  <a
                    href="https://github.com/rNoureen64/Product_Catalog_API"
                    target="_blank"
                    rel="noreferrer"
                    className="project-btn primary-project-btn"
                  >
                    View GitHub <span>↗</span>
                  </a>
                  <a
                    href="#catalog-details"
                    className="project-btn secondary-project-btn"
                  >
                    Project Details
                  </a>
                </div>
              </div>
            </article>

            <article className="project-card featured-project">
              <div className="project-visual api-visual">
                <div className="api-header">
                  <span className="api-method">FULL STACK</span>
                  <span>NovaMart Store</span>
                </div>
                <div className="api-response">
                  <div>
                    <span className="json-key">"project"</span>
                    <span>: "NovaMart",</span>
                  </div>
                  <div>
                    <span className="json-key">"frontend"</span>
                    <span>: "React.js",</span>
                  </div>
                  <div>
                    <span className="json-key">"backend"</span>
                    <span>: "Node.js + Express",</span>
                  </div>
                  <div>
                    <span className="json-key">"database"</span>
                    <span>: "MongoDB"</span>
                  </div>
                </div>
                <div className="api-status">
                  <span>●</span>
                  E-Commerce Project
                </div>
              </div>
              <div className="project-content">
                <div className="project-meta">
                  <span>03</span>
                  <span>FULL-STACK WEB APPLICATION</span>
                </div>
                <h3>NovaMart</h3>
                <p>
                  A full-stack e-commerce application featuring product
                  browsing, category filtering, shopping cart functionality,
                  a checkout demo and an inventory overview.
                </p>
                <div className="project-features">
                  <span>✓ Product Catalog</span>
                  <span>✓ Shopping Cart</span>
                  <span>✓ Category Filtering</span>
                  <span>✓ Backend Integration</span>
                </div>
                <div className="tags">
                  <span>React.js</span>
                  <span>Node.js</span>
                  <span>Express.js</span>
                  <span>MongoDB</span>
                </div>
                <div className="project-actions">
                  <a
                    href="https://github.com/rNoureen64/Syntecxhub_NovaMart"
                    target="_blank"
                    rel="noreferrer"
                    className="project-btn primary-project-btn"
                  >
                    View GitHub <span>↗</span>
                  </a>
                  <a
                    href="#novamart-details"
                    className="project-btn secondary-project-btn"
                  >
                    Project Details
                  </a>
                </div>
              </div>
            </article>
          </div>
        </section>

        <section className="project-details section" id="expenseflow-details">
          <div className="section-label">PROJECT 01 — EXPENSEFLOW</div>
          <div className="details-header">
            <div>
              <p className="eyebrow">CASE STUDY</p>
              <h2>
                A modern finance dashboard built for everyday money
                management.
              </h2>
            </div>
            <p>
              ExpenseFlow is a responsive personal finance application
              designed to make tracking income, expenses, budgets and
              financial activity simple and organized.
            </p>
          </div>
          <div className="details-grid">
            <div className="details-card">
              <span>01</span>
              <h3>Dashboard</h3>
              <p>
                A clean financial dashboard displaying balance, income,
                expenses and important financial insights at a glance.
              </p>
            </div>
            <div className="details-card">
              <span>02</span>
              <h3>Transactions</h3>
              <p>
                Users can manage income and expenses while keeping
                financial activity organized in one place.
              </p>
            </div>
            <div className="details-card">
              <span>03</span>
              <h3>Analytics</h3>
              <p>
                Interactive charts provide a visual understanding of
                spending patterns and financial activity.
              </p>
            </div>
            <div className="details-card">
              <span>04</span>
              <h3>Smart Features</h3>
              <p>
                Includes budgets, recurring transactions, notifications,
                dark mode, local storage and responsive layouts.
              </p>
            </div>
          </div>
          <div className="details-bottom">
            <div>
              <p className="details-label">TECHNOLOGIES</p>
              <div className="tags">
                <span>React.js</span>
                <span>JavaScript</span>
                <span>Recharts</span>
                <span>CSS3</span>
                <span>LocalStorage</span>
              </div>
            </div>
            <a
              href="https://github.com/rNoureen64/Syntecxhub_ExpenseFlow"
              target="_blank"
              rel="noreferrer"
              className="primary-btn"
            >
              Explore Source Code <span>↗</span>
            </a>
          </div>
        </section>

        <section className="project-details section" id="catalog-details">
          <div className="section-label">PROJECT 02 — PRODUCT CATALOG API</div>
          <div className="details-header">
            <div>
              <p className="eyebrow">BACKEND CASE STUDY</p>
              <h2>
                A production-style REST API built for scalable product
                catalog management.
              </h2>
            </div>
            <p>
              Product Catalog API is a secure backend system designed to
              manage products through authenticated endpoints while
              supporting search, filtering, pagination, validation and
              MongoDB-based analytics.
            </p>
          </div>
          <div className="details-grid">
            <div className="details-card">
              <span>01</span>
              <h3>Authentication</h3>
              <p>
                Secure user registration and login with password hashing,
                JWT authentication and protected API endpoints.
              </p>
            </div>
            <div className="details-card">
              <span>02</span>
              <h3>Product CRUD</h3>
              <p>
                Complete product creation, retrieval, updating and
                soft-deletion functionality using RESTful API design.
              </p>
            </div>
            <div className="details-card">
              <span>03</span>
              <h3>Search &amp; Pagination</h3>
              <p>
                Product search, category filtering, price filtering and
                pagination for efficient catalog browsing.
              </p>
            </div>
            <div className="details-card">
              <span>04</span>
              <h3>Analytics</h3>
              <p>
                MongoDB aggregation pipelines provide useful product
                statistics and catalog insights.
              </p>
            </div>
            <div className="details-card">
              <span>05</span>
              <h3>Validation</h3>
              <p>
                Request validation, parameter checks and centralized
                error handling improve API reliability and consistency.
              </p>
            </div>
            <div className="details-card">
              <span>06</span>
              <h3>Security</h3>
              <p>
                Helmet, CORS, rate limiting, authentication middleware
                and controlled update fields strengthen API security.
              </p>
            </div>
            <div className="details-card">
              <span>07</span>
              <h3>Database</h3>
              <p>
                MongoDB and Mongoose are used for structured data
                modeling, indexing and efficient database operations.
              </p>
            </div>
            <div className="details-card">
              <span>08</span>
              <h3>API Testing</h3>
              <p>
                Endpoints were tested with Postman covering authentication,
                CRUD operations, validation and protected routes.
              </p>
            </div>
          </div>
          <div className="details-bottom">
            <div>
              <p className="details-label">TECHNOLOGIES</p>
              <div className="tags">
                <span>Node.js</span>
                <span>Express.js</span>
                <span>MongoDB</span>
                <span>Mongoose</span>
                <span>JWT</span>
                <span>Postman</span>
              </div>
            </div>
            <a
              href="https://github.com/rNoureen64/Product_Catalog_API"
              target="_blank"
              rel="noreferrer"
              className="primary-btn"
            >
              Explore Source Code <span>↗</span>
            </a>
          </div>
        </section>

        <section className="project-details section" id="novamart-details">
          <div className="section-label">PROJECT 03 — NOVAMART</div>
          <div className="details-header">
            <div>
              <p className="eyebrow">FULL-STACK CASE STUDY</p>
              <h2>
                A modern e-commerce experience for browsing and managing
                products.
              </h2>
            </div>
            <p>
              NovaMart is a full-stack e-commerce project combining a
              React frontend with a Node.js and Express backend and
              MongoDB database integration.
            </p>
          </div>
          <div className="details-grid">
            <div className="details-card">
              <span>01</span>
              <h3>Product Catalog</h3>
              <p>
                Browse products with category information, pricing and
                organized product listings.
              </p>
            </div>
            <div className="details-card">
              <span>02</span>
              <h3>Shopping Cart</h3>
              <p>
                Explore cart functionality designed to support a
                straightforward shopping experience.
              </p>
            </div>
            <div className="details-card">
              <span>03</span>
              <h3>Backend Integration</h3>
              <p>
                Connect the React application with an Express API and
                MongoDB-backed product data.
              </p>
            </div>
            <div className="details-card">
              <span>04</span>
              <h3>Inventory Overview</h3>
              <p>
                View product names, categories and prices in a clean,
                responsive inventory layout.
              </p>
            </div>
          </div>
          <div className="details-bottom">
            <div>
              <p className="details-label">TECHNOLOGIES</p>
              <div className="tags">
                <span>React.js</span>
                <span>Node.js</span>
                <span>Express.js</span>
                <span>MongoDB</span>
                <span>CSS3</span>
              </div>
            </div>
            <a
              href="https://github.com/rNoureen64/Syntecxhub_NovaMart"
              target="_blank"
              rel="noreferrer"
              className="primary-btn"
            >
              Explore Source Code <span>↗</span>
            </a>
          </div>
        </section>

        <section className="experience section" id="experience">
          <div className="section-label">04 — EXPERIENCE</div>
          <div className="experience-wrapper">
            <div className="experience-main">
              <div className="experience-top">
                <div>
                  <p className="project-type">SEPTEMBER 2026 — PRESENT</p>
                  <h2>Web Development Intern</h2>
                  <h3>Syntecxhub</h3>
                </div>
                <div className="experience-status">
                  <span></span>
                  Remote
                </div>
              </div>
              <p className="experience-summary">
                Building practical web development projects using modern
                frontend and backend technologies while following real-world
                development practices, API workflows and version control.
              </p>
              <div className="experience-points">
                <div>
                  <span>01</span>
                  <p>
                    Developed responsive web applications using React.js,
                    JavaScript, HTML5 and CSS3.
                  </p>
                </div>
                <div>
                  <span>02</span>
                  <p>
                    Built REST APIs with Node.js and Express.js including
                    CRUD operations and authentication.
                  </p>
                </div>
                <div>
                  <span>03</span>
                  <p>
                    Worked with MongoDB and Mongoose for database modeling
                    and data management.
                  </p>
                </div>
                <div>
                  <span>04</span>
                  <p>
                    Tested API functionality and protected endpoints using
                    Postman while maintaining projects with Git and GitHub.
                  </p>
                </div>
              </div>
              <div className="experience-tech">
                <span>React.js</span>
                <span>JavaScript</span>
                <span>Node.js</span>
                <span>Express.js</span>
                <span>MongoDB</span>
                <span>Git</span>
                <span>GitHub</span>
                <span>Postman</span>
              </div>
            </div>
            <div className="experience-side">
              <div className="experience-number">01</div>
              <p>CURRENT ROLE</p>
              <strong>Building. Testing. Learning.</strong>
              <span>
                Focused on turning technical concepts into practical,
                portfolio-ready applications.
              </span>
            </div>
          </div>
        </section>

        <section className="contact section" id="contact">
          <div className="section-label">05 — CONTACT</div>
          <div className="contact-wrapper">
            <div className="contact-main">
              <p className="eyebrow">LET’S WORK TOGETHER</p>
              <h2>
                Have a project in mind?
                <span> Let’s build it.</span>
              </h2>
              <p className="contact-description">
                I’m available for freelance projects, web development
                opportunities and collaborations. Whether you need a
                responsive frontend, REST API or complete web application,
                I’d love to hear about your idea.
              </p>
              <div className="contact-actions">
                <a href="mailto:rnoureen64@gmail.com" className="primary-btn">
                  Start a Conversation <span>↗</span>
                </a>
                <a
                  href="https://www.upwork.com/freelancers/~01af9c67372ac512a2"
                  target="_blank"
                  rel="noreferrer"
                  className="secondary-btn"
                >
                  Hire Me on Upwork <span>↗</span>
                </a>
              </div>
            </div>
            <div className="contact-side">
              <div className="contact-item">
                <span>EMAIL</span>
                <a href="mailto:rnoureen64@gmail.com">
                  rnoureen64@gmail.com
                </a>
              </div>
              <div className="contact-item">
                <span>PROFILES</span>
                <div className="contact-links">
                  <a
                    href="https://github.com/rNoureen64"
                    target="_blank"
                    rel="noreferrer"
                  >
                    GitHub ↗
                  </a>
                  <a
                    href="https://www.linkedin.com/in/rabail-noureen-367b85390"
                    target="_blank"
                    rel="noreferrer"
                  >
                    LinkedIn ↗
                  </a>
                  <a
                    href="https://www.upwork.com/freelancers/~01af9c67372ac512a2"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Upwork ↗
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <span>AVAILABILITY</span>
                <div className="contact-availability">
                  <span></span>
                  Open to freelance opportunities
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer>
        <p>© 2026 Rabail Noureen. Built with React.js.</p>
        <div>
          <a
            href="https://github.com/rNoureen64"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/rabail-noureen-367b85390"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
          <a
            href="https://www.upwork.com/freelancers/~01af9c67372ac512a2"
            target="_blank"
            rel="noreferrer"
          >
            Upwork
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
